// these are defined in the on pardot in the form handler
export const formFields = {
  email: 'email',
  first_name: 'first_name',
  last_name: 'last_name',
  company: 'company',
  // Free-text job title (demo form, #3426) → persona mapping/routing downstream
  // (technical champion → PSC vs AE). Must match the field name in the demo Pardot handler.
  job_title: 'job_title',
  build_tools: 'build_tools',
  pain_points: 'pain_points',
  role: 'role',
  areas_of_interest: 'areas_of_interest',
  message: 'message',
  ci_tools: 'ci_tools',
  dependency_provider: 'dependency_provider',
  dependency_bottleneck: 'dependency_bottleneck',
} as const;

// The caseing here needs to match the caseing in the pardot form handler
export const painPointOptions = [
  { label: 'Build Speed', value: 'Build Speed' },
  { label: 'Dependency Issues', value: 'Dependency Issues' },
  { label: 'Debugging Builds', value: 'Debugging Builds' },
  { label: 'Build Reliability', value: 'Build Reliability' },
  { label: 'Flaky Tests', value: 'Flaky Tests' },
  { label: 'Other', value: 'Other' },
];

// The caseing here needs to match the caseing in the pardot form handler
export const buildToolOptions = [
  { label: 'Gradle', value: 'Gradle' },
  { label: 'Maven', value: 'Maven' },
  { label: 'CMake', value: 'CMake' },
  { label: 'npm', value: 'npm' },
  { label: 'Python', value: 'Python' },
  { label: 'sbt', value: 'sbt' },
  { label: 'Bazel', value: 'Bazel' },
  // Added to the Salesforce + Pardot build_tools picklist by MOps (Thomas Williams, 30 Oct 2026)
  { label: 'Docker', value: 'Docker' },
  { label: 'Other', value: 'Other' },
];

export const roleOptions = [
  { label: 'Productivity / Platform Engineer', value: 'Productivity / Platform Engineer' },
  { label: 'Build Engineer', value: 'Build Engineer' },
  { label: 'DevOps/CI Engineers', value: 'DevOps/CI Engineers' },
  { label: 'Senior/Lead Software Developer', value: 'Senior/Lead Software Developer' },
  { label: 'Application/Software Developer', value: 'Application/Software Developer' },
  { label: 'VP / Director of Engineering', value: 'VP / Director of Engineering' },
  { label: 'Other', value: 'Other' },
];

export const ciToolOptions = [
  { label: 'Jenkins', value: 'Jenkins' },
  { label: 'GitHub Actions', value: 'GitHub Actions' },
  { label: 'GitLab', value: 'GitLab' },
  { label: 'Jetbrains TeamCity', value: 'Jetbrains TeamCity' },
  { label: 'Other', value: 'Other' },
];

export const dependencyProviderOptions = [
  { label: 'Artifactory', value: 'Artifactory' },
  { label: 'Nexus', value: 'Nexus' },
  { label: 'Other', value: 'Other' },
];

export const dependencyBottleneckOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export function validateEmail(email: string) {
  // this regex matched pardots server side validation
  if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
    return 'Please enter a valid email address.';
  }
  return null;
}
